import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import StyledTextVariant from "%/dynamic-component-editor/options/styled-text-variant";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import TextBrandingStyleOption from "%/dynamic-component-editor/options/text-branding-style-option";
import TextOption from "%/dynamic-component-editor/options/text-option";

export default class BrandedTextStyleOptions extends BaseOptionsBundle {

  optionTitle = "Styled Text";
  static optionClassName = "i-dynamic-text";
  inspectorToolGroup = "styled-text";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.STYLED_TEXT_TOOL_SET,
  };

  constructor(values = {}, shouldHideFromInspector = {}) {
    super(values, [
      new TextBrandingStyleOption(undefined, shouldHideFromInspector["text-branding-style-option"] ?? false),
      new StyledTextVariant(undefined, shouldHideFromInspector["styled-text-variant"] ?? false),
      new TextOption(undefined, shouldHideFromInspector["text-option"] ?? false),
    ]);
  }
}
